import { FunctionComponent, useEffect, useRef, useState } from "react";
import CalIcon from "../../assets/task/calendar-icon.svg";
import teamMembersimg from "../../assets/task/teammeambers_img.svg";
import tripleDot from "../../assets/task/triple_dot.svg";
import statusIocn from "../../assets/task/status.png";
import dependencyIcon from "../../assets/task/dependency.png";
import ditTaskicon from "../../assets/task/editing.png";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export function classForStatus(statusName: string) {
    switch (statusName) {
        case 'Closed':
            return 'green_status_bg_dv';
        case 'In Progress':
            return 'yellow_status_bg_dv';
        case 'Testing':
            return 'yellow_status_bg_dv';
        case 'Not Started':
            return 'blue_status_bg_dv';
        default:
            return '';
    }
}

interface GoalTaskViewProps {
    task: any
    hasClockedIn: boolean
}

const GoalTaskView: FunctionComponent<GoalTaskViewProps> = ({ task, hasClockedIn }) => {
    const { userInfo } = useAuth()
    const navigate = useNavigate()

    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    const createdOnDate = task?.created_on
        ? format(task?.created_on, 'MMM dd, yyyy') : ""

    const dueDate = task?.end_datetime
        ? format(task?.end_datetime, 'MMM dd, yyyy') : ""

    const initial = task?.assigned_to_name?.charAt(0)?.toUpperCase() || '';
    const secondInitial = task?.assigned_to_name?.split(" ")[1].charAt(0)?.toUpperCase() || ''

    const employeeID = userInfo?.employee_id

    const isTaskAssignedToCurrentUser = task?.assigned_to_id == employeeID;

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setMenuOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="task_section_dv gap-[16px]  self-stretch rounded border-whitesmoke border-solid border-[1px] box-border flex flex-col items-start justify-center p-4">
            <div className="w-full overflow-hidden flex flex-row items-center justify-between gap-0 text-lg">
                <b className="relative"></b>
                <h5 className="my-0 flex-1 relative inline-block max-w-full dark:text-white"><b className="flex-1 relative whitespace-pre-wrap">{task?.title}</b></h5>
                <div className="flex gap-[10px] ">
                    <div className={`rounded-[50px] bg-antiquewhite border-whitesmoke border-solid border-[1px] box-border flex flex-row items-center justify-center py-1 px-4 text-base ${classForStatus(task?.status_name)}`}>
                        <div className="relative">{task?.status_name}</div>
                    </div>
                    {/* <div className="rounded-[50px] close-status_bg border-whitesmoke border-solid border-[1px] box-border flex flex-row items-center justify-center py-1 px-4 text-base">
                    <p className="relative my-0 text-sm dark:text-white">Close</p>
                </div>
                <div className="rounded-[50px] notstarted-status_bg border-whitesmoke border-solid border-[1px] box-border flex flex-row items-center justify-center py-1 px-4 text-base">
                    <p className="relative my-0 text-sm dark:text-white">In Progress</p>
                </div> */}
                    {task?.task_tags?.length > 0 && (
                        task?.task_tags?.map((t: any) => {
                            return (
                                <div className="rounded-[50px] right_status_clockout border-whitesmoke border-solid border-[1px] box-border flex flex-row items-center justify-center py-1 px-4 text-base">
                                    <div className="relative text-white">{t?.tags_name}</div>
                                </div>
                            )
                        })
                    )}
                </div>
            </div>
            <hr className="bdr-custom-taskcrad" />
            <div className="w-full overflow-hidden shrink-0 flex flex-row items-center justify-between gap-0">
                <div className="relative font-semibold">{task?.static_task_type_name}</div>
                <div className=" flex flex-row items-center justify-center box-border gap-1 text-center text-white">
                    {/* <img className="w-4 relative h-4 overflow-hidden shrink-0" alt="" src="left-icon.svg" /> */}
                    {/* {(hasClockedIn && isTaskAssignedToCurrentUser) && (
                        <>
                            <button className="cursor-pointer [border:none] py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px] bg-surface-primary-surface rounded-radiuscomponent-button flex flex-row items-center justify-center gap-[12px] hover:bg-dodgerblue"
                                onClick={() => {
                                    navigate('/change_status', {
                                        state: {
                                            task: task
                                        }
                                    })
                                }}
                            >
                                <span className="relative text-sm font-body-xs-semi-bold text-surface-bg-primary text-center grid">Change Status</span>

                            </button>
                            <button className="cursor-pointer [border:none] py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px] bg-surface-primary-surface rounded-radiuscomponent-button flex flex-row items-center justify-center gap-[12px] hover:bg-dodgerblue"
                                onClick={() => {
                                    navigate('/add_dependency', {
                                        state: {
                                            taskID: task?.id
                                        }
                                    })
                                }}
                            >
                                <span className="relative text-sm font-body-xs-semi-bold text-surface-bg-primary text-center grid">Add Dependency</span>
                            </button>
                            {task?.status_name !== "Closed" && (
                                <button className="cursor-pointer [border:none] py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px] bg-surface-primary-surface rounded-radiuscomponent-button flex flex-row items-center justify-center gap-[12px] hover:bg-dodgerblue"
                                    onClick={() => navigate('/edit_task', {
                                        state: {
                                            task
                                        }
                                    })}
                                >
                                    <span className="relative text-sm font-body-xs-semi-bold text-surface-bg-primary text-center grid">Edit Task</span>
                                </button>
                            )}
                        </>
                    )} */}

                    {/* Triple Dot Button and Popup */}
                    {(hasClockedIn && isTaskAssignedToCurrentUser) && (
                        <div className="relative edittask-popup-dv" ref={menuRef}>
                            <img
                                src={tripleDot}
                                alt="More Options"
                                className="w-6 h-6 cursor-pointer relative left-[-4 px]"
                                onClick={() => setMenuOpen(prev => !prev)}
                            />
                            {menuOpen && (
                                <div className="inner_edittask-popup-dv">
                                    <button
                                        className="text-left text-sm hover:bg-gray-100 p-2 rounded"
                                        onClick={() => {
                                            navigate('/change_status', { state: { task } });
                                            setMenuOpen(false);
                                        }}
                                    >

                                        <img
                                            src={statusIocn}
                                            alt="More Options"
                                            className="w-4 h-4 cursor-pointer"
                                        /> <span>Change Status</span>
                                    </button>
                                    <button
                                        className="text-left text-sm hover:bg-gray-100 p-2 rounded"
                                        onClick={() => {
                                            navigate('/add_dependency', { state: { taskID: task?.id } });
                                            setMenuOpen(false);
                                        }}
                                    >

                                        <img
                                            src={dependencyIcon}
                                            alt="More Options"
                                            className="w-4 h-4 cursor-pointer"
                                        /> <span> Add Dependency</span>

                                    </button>
                                    {task?.status_name !== "Closed" && (
                                        <button
                                            className="text-left text-sm hover:bg-gray-100 p-2 rounded"
                                            onClick={() => {
                                                navigate('/edit_task', { state: { task } });
                                                setMenuOpen(false);
                                            }}
                                        >
                                            <img
                                                src={ditTaskicon}
                                                alt="More Options"
                                                className="w-4 h-4 cursor-pointer"
                                            /> <span>Edit Task</span>

                                        </button>
                                    )}
                                </div>
                            )}
                        </div>
                    )}

                </div>
            </div>
            {/* <div className="w-full relative text-dimgray whitespace-pre-wrap inline-block">{task?.static_task_type_name}</div> */}

            <div className="self-stretch flex flex-row items-center justify-start py-0 px-2 gap-2.5">
                <div className="flex flex-row items-center justify-center gap-1.5">
                    {/* <img className="w-6 relative max-h-full overflow-hidden shrink-0 hidden" alt="" src="manager_svgrepo.com.svg" />
                                        <img className="w-[18.5px] relative h-[17.8px] hidden" alt="" src="Group 609.svg" />
                                        <img className="w-[18.5px] relative h-[17.8px]" alt="" src="Group 610.svg" /> */}
                    <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={CalIcon} />
                    <div className="relative">Created Date</div>
                </div>
                <div className="flex flex-row items-center justify-center text-dimgray">
                    <div className="relative">{createdOnDate}</div>
                </div>
            </div>
            <div className="self-stretch flex flex-row items-center justify-start py-0 px-2 gap-2.5">
                <div className="flex flex-row items-center justify-center gap-1.5">
                    {/* <img className="w-6 relative max-h-full overflow-hidden shrink-0 hidden" alt="" src="manager_svgrepo.com.svg" />
                                        <img className="w-[18.5px] relative h-[17.8px] hidden" alt="" src="Group 609.svg" />
                                        <img className="w-[18.5px] relative h-[17.8px]" alt="" src="Group 610.svg" /> */}
                    <img className="w-5 relative h-5 overflow-hidden shrink-0 cursor-pointer" alt="" src={CalIcon} />
                    <div className="relative">Due Date</div>
                </div>
                <div className="flex flex-row items-center justify-center text-dimgray">
                    <div className="relative">{dueDate}</div>
                </div>
            </div>
            <div className="grid grid-cols-4 mq1400:grid-4 mq1275:grid-cols-3 mq950:grid-cols-2 mq575:grid-cols-1 gap-[16px] min-w-full">
                <div className="lightgary_bg_dv flex-1 rounded bg-whitesmoke-100 border-whitesmoke border-solid border-[1px] box-border box-border flex flex-row items-center justify-start p-2">
                    <div className="flex flex-row items-center justify-start gap-1">
                        {/* <img className="w-9 rounded-full h-9 overflow-hidden shrink-0" alt="" src={teamMembersimg} /> */}
                        {/* Initial Avatar */}
                        <div className="w-9 h-9 rounded-full bg-gray-500 flex items-center justify-center text-white font-semibold text-sm cursor-default">
                            {`${initial} ${secondInitial}`}
                        </div>
                        <div className="relative">Assignee : {task?.assigned_to_name}</div>
                    </div>
                </div>
            </div>
            <div className="w-full flex flex-row items-start justify-start flex-wrap content-start pt-0 px-0 pb-4 box-border gap-2">
                <div className="w-full overflow-hidden shrink-0 flex flex-row items-center justify-between gap-0">
                    <div className="relative font-semibold">Activities</div>
                    {/* <img className="w-4 rounded-[50px] h-4 overflow-hidden shrink-0" alt="" src={tripleDot} /> */}
                </div>
                <hr className="bdr-custom-taskcrad" />
                <div className="flex-1 flex flex-col items-start justify-center gap-2 overflow-hidden">
                    <div className="viewdoclist_tabel_blg min-w-full overflow-hidden assessorform_main_tbl client-hist-main">
                        <div className=" bg-white dark:dark:bg-slate-700 flex flex-col items-start justify-start gap-[24px] overflow-x-auto client-report-dtnamic-tbl"
                            id="onboarding-tbl">
                            <table className="min-w-full text-left text-sm text-gray-800  table self-stretch border-[1px] border-solid border-surface-border rounded-lg overflow-x-auto dynamictabel-main-dv">
                                <thead className="bg-gray-100 text-gray-600 uppercase text-xs sticky top-0 z-10">
                                    <tr>
                                        <th className="px-4 py-2 border-b">Date Time</th>
                                        <th className="px-4 py-2 border-b">Name</th>
                                        <th className="px-4 py-2 border-b">Status</th>
                                        <th className="px-4 py-2 border-b">Comment</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {task?.activities?.length > 0 ? (
                                        task.activities.map((a: any, idx: number) => {
                                            const activityDate = format(a?.created_on, `MM-dd-yyyy (h:mm a)`)
                                            return (
                                                <tr key={idx} className="border-b hover:bg-gray-50">
                                                    <td className="px-4 py-2 whitespace-nowrap">{activityDate}</td>
                                                    <td className="px-4 py-2 font-semibold">{a?.created_by_name}</td>
                                                    <td className="px-4 py-2 font-semibold">{a?.status_name}</td>
                                                    <td className="px-4 py-2 text-gray-700">{a?.comment}</td>
                                                </tr>
                                            )
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={4} className="text-center py-4 text-gray-400">
                                                No activities found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Optional "View More" link */}
                    {/* <div className="self-stretch flex flex-row items-center justify-center py-0 px-6 text-darkmagenta">
    <a className="flex-1 relative purple-link-dv" href="#">View More</a>
  </div> */}
                </div>

                {/* <div className="flex-1 flex flex-col items-start justify-center gap-2 overflow-hidden ">
                    <div className="self-stretch relative max-h-[200px] overflow-y-auto">
                        <ul className="m-0 font-inherit text-[length:inherit] pl-[21px] gap-[8px] grid ">
                            {task?.activities?.length > 0 && task?.activities?.map((a: any) => {
                                const activityDate = format(a?.created_on, `MM-dd-yyyy (h:mm a)`)
                                return (
                                    <li>
                                        <span className="text-dimgray pr-[4px]">{activityDate}:</span>
                                        <span className="font-semibold">{a?.created_by_name}</span> <span className="text-dimgray">changes status to</span> <span className="font-semibold">{a?.status_name} : </span>
                                        <span className="text-dimgray">{a?.comment}</span>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div> */}
            </div>
            <hr className="bdr-custom-taskcrad" />
        </div>
    )
}

export default GoalTaskView